const Util = {
  getScrollBarWidth() {
    // Create the measurement node

    const scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  },
};

export default Util;



// WEBPACK FOOTER //
// ./src/scripts/components/helpers/index.js